import { render, staticRenderFns } from "./TeacherPaymentSlip.vue?vue&type=template&id=733b3579&"
import script from "./TeacherPaymentSlip.vue?vue&type=script&lang=js&"
export * from "./TeacherPaymentSlip.vue?vue&type=script&lang=js&"
import style0 from "./TeacherPaymentSlip.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports